// extracted by mini-css-extract-plugin
export default {"logoButton":"style_logoButton__30nIl","content":"style_content__VGnq7"};